<span [ngSwitch]="test">
  <span *ngSwitchCase="'valid'">
    <app-verification-valid></app-verification-valid>
  </span>
  <span *ngSwitchCase="'invalid'">
    <app-verification-invalid></app-verification-invalid>
  </span>
  <span *ngSwitchCase="'inactive'">
    <app-verification-inactive></app-verification-inactive>
  </span>
  <span *ngSwitchDefault> </span>
</span>
